
    
    ;() => import("__mf__virtual/discovery__prebuild__vue__prebuild__.js").catch(() => {});
    // dev uses dynamic import to separate chunks
    
    const {loadShare} = require("@module-federation/runtime")
    const {initPromise} = require("__mf__virtual/discovery__mf_v__runtimeInit__mf_v__.js")
    const res = initPromise.then(_ => loadShare("vue", {
    customShareInfo: {shareConfig:{
      singleton: true,
      strictVersion: false,
      requiredVersion: "^3.4.21"
    }}}))
    const exportModule = await res.then(factory => factory())
    module.exports = exportModule
  